import axios from 'axios';
import Vue from 'vue'
// import Swal from "sweetalert2";

export default {
    
    sendForm(merchandisingForm){

      return axios.post('/api/merchandising/send', merchandisingForm)
      .then(response => {
          if (response && response.data) {
              return response.data
          } 
      })
      .catch(error => {Vue.prototype.$snotify.error(error);})

        // return axios({
        //     url:'/api/merchandising/send',
        //     method: 'POST',
        //     data: merchandisingForm,
        //     responseType: 'blob', // important
        //   }).then((response) => {
        //     if(response && response.data){
        //       return response.data
        //     }

        //   }).catch(() => {
        //       Vue.prototype.$snotify.error("La géneration et l'envoi du formulaire ont échoué");});
    },

}

